import { useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { displayNameToInitials } from '../../lib/displayUtils';
import { ContactSvg } from '../defaultSvgIcons/ContactSvg';
import { TextSvg } from '../defaultSvgIcons/TextSvg';
import { jsx as _jsx } from "react/jsx-runtime";
export const AvatarContactInitials = ({
  displayName
}) => {
  const content = useMemo(() => displayNameToInitials({
    displayName,
    aString: displayName
  }), [displayName]);
  if (!content) {
    return /*#__PURE__*/_jsx(ContactSvg, {});
  }
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    justifyContent: "center",
    inlineSize: "100%",
    blockSize: "100%",
    children: /*#__PURE__*/_jsx(TextSvg, {
      fontSize: "290%",
      children: content
    })
  });
};